<div #popup>
  <div
    *ngIf="{
      location: popupLocation$ | async,
      isLoading: isLoading$ | async,
      canAddStop: canAddStop$ | async,
      isFavoritePlace: isFavoritePlace$ | async,
      isSharedFavorite: isSharedFavorite$ | async,
      isPremium: isPremium$ | async,
      hasAdminRole: hasAdminRole$ | async
    } as p"
  >
    <ng-container *ngIf="!p.isLoading && marker; else loading">
      <ng-container *ngIf="p.location?.address; else error">
        <div>
          <h4>
            {{ p.location.address?.streetAddress }}
          </h4>
          <p>
            {{ p.location.address?.city }},
            {{ p.location.address?.stateAbbreviation }},
            {{ p.location.address?.zip }}
          </p>
        </div>
        <div class="d-flex justify-content-between mt-2">
          <!-- case 1: not premium user -->
          <span
            *ngIf="!p.isPremium"
            class="btn btn-icon-only"
            style="cursor: auto"
          >
            <img
              src="../assets/img/icons/star_outline.svg"
              class="d-flex"
              style="margin-left: -6px; margin-top: -4px; opacity: 0.3"
            />
          </span>
          <!-- case 2 and the rest: premium user -->
          <!-- case 2 shared favorite and admin role -->
          <span
            *ngIf="p.isPremium && p.isSharedFavorite && p.hasAdminRole"
            class="btn btn-icon-only"
            (click)="removeFavorite(p.location)"
            container="body"
            [adaptivePosition]="false"
            tooltip="Remove From Favorites"
          >
            <img
              src="../assets/img/icons/star_locked.svg"
              class="d-flex"
              style="margin-left: -6px; margin-top: -4px"
            />
          </span>
          <!-- case 3 shared favorite but not admin -->
          <span
            *ngIf="p.isPremium && p.isSharedFavorite && !p.hasAdminRole"
            class="btn btn-icon-only"
            style="cursor: auto"
          >
            <img
              src="../assets/img/icons/star_locked.svg"
              class="d-flex"
              style="margin-left: -6px; margin-top: -4px; opacity: 0.3"
            />
          </span>
          <!-- case 4 is favorite -->
          <span
            *ngIf="p.isPremium && !p.isSharedFavorite && p.isFavoritePlace"
            class="btn btn-icon-only"
            (click)="removeFavorite(p.location)"
            container="body"
            [adaptivePosition]="false"
            tooltip="Remove From Favorites"
          >
            <img
              src="../assets/img/icons/star.svg"
              class="d-flex"
              style="margin-left: -6px; margin-top: -4px"
            />
          </span>
          <!-- case 5 is not favorite yet -->
          <span
            *ngIf="p.isPremium && !p.isSharedFavorite && !p.isFavoritePlace"
            class="btn btn-icon-only"
            (click)="addSave(p.location)"
            container="body"
            [adaptivePosition]="false"
            tooltip="Save As Favorite"
          >
            <img
              src="../assets/img/icons/star_outline.svg"
              class="d-flex"
              style="margin-left: -6px; margin-top: -4px"
            />
          </span>
          <button
            class="btn btn-sm btn-primary"
            (click)="addStop(p.location)"
            [disabled]="!p.canAddStop"
          >
            Add Stop
          </button>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-template #loading>
  <div class="px-3" *ngIf="marker">
    <div class="text-center text-primary">
      <div class="spinner-border"></div>
      <div class="h4 text-primary mt-3">Loading...</div>
    </div>
  </div>
</ng-template>

<ng-template #error>
  <div *ngIf="errorMessage$ | async as errorMessage">
    <h5 class="mt-2">No address found here</h5>
  </div>
</ng-template>
